import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 5.3335H11.3333V4.66683C11.3333 2.82683 9.84 1.3335 8 1.3335C6.16 1.3335 4.66667 2.82683 4.66667 4.66683V5.3335H4.00001C3.26667 5.3335 2.66667 5.9335 2.66667 6.66683V12.0002C2.66667 12.7335 3.26667 13.3335 4.00001 13.3335H12C12.7333 13.3335 13.3333 12.7335 13.3333 12.0002V6.66683C13.3333 5.9335 12.7333 5.3335 12 5.3335ZM8 10.6668C7.26667 10.6668 6.66667 10.0668 6.66667 9.3335C6.66667 8.60016 7.26667 8.00016 8 8.00016C8.73334 8.00016 9.33334 8.60016 9.33334 9.3335C9.33334 10.0668 8.73334 10.6668 8 10.6668ZM6 5.3335V4.66683C6 3.56016 6.89334 2.66683 8 2.66683C9.10667 2.66683 10 3.56016 10 4.66683V5.3335H6Z",
		fill: "#424D57"
	})
});
export default SvgLock;
